import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
// import QrCodes from './pages/QrCodes'; // Soft-removed: replaced by CustomizeQrPage
import NotFound from './pages/NotFound';
import { ProtectedRoute, AuthCallback, LogoutCallback, SilentRenew } from './auth';
import { SiteProvider, SiteEntryView, SiteLayout, SiteOverview } from './site';
import { CustomizeQrPage } from './qr-customize';
import { BrandingPage } from './branding';
import { SiteFeaturesPage } from './site-features';
import { EgoDeviceListView, EgoDeviceSetupView, EgoDeviceEditView } from './ego';
import { SiteMapRoute } from './site-map';
import { AnalyticsProvider } from './analytics';

const App: React.FC = () => {
  return (
    <AnalyticsProvider>
      <SiteProvider>
      <Routes>
        {/* Auth callback routes - outside protected area */}
        <Route path="/auth-callback" element={<AuthCallback />} />
        <Route path="/logout-callback" element={<LogoutCallback />} />
        <Route path="/silent-renew" element={<SilentRenew />} />
        
        {/* Protected routes - require authentication */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          {/* Dashboard - full-width home view */}
          <Route index element={<Dashboard />} />
          
          {/* Site entry view */}
          <Route path="site" element={<SiteEntryView />} />
          
          {/* Site-specific routes */}
          <Route path="site/:siteId" element={<SiteLayout />}>
            <Route index element={<SiteOverview />} />
            {/* <Route path="qr-codes" element={<QrCodes />} /> */}{/* Soft-removed: replaced by CustomizeQrPage */}
            <Route path="customize-qr" element={<CustomizeQrPage />} />
            <Route path="branding" element={<BrandingPage />} />
            <Route path="features" element={<SiteFeaturesPage />} />
          </Route>
          
          {/* Site map - fleet-wide, behind the advanced=true soft flag while it rolls out */}
          <Route path="site-map" element={<SiteMapRoute fallback={<NotFound />} />} />

          {/* eGO device management routes — always accessible regardless of feature flag */}
          <Route path="ego" element={<EgoDeviceListView />} />
          <Route path="ego/setup" element={<EgoDeviceSetupView />} />
          <Route path="ego/:deviceId" element={<EgoDeviceEditView />} />
          
          <Route path="*" element={<NotFound />} />
        </Route>
      </Routes>
    </SiteProvider>
    </AnalyticsProvider>
  );
};

export default App;
